import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData, restApiBlob } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const usersAPI = createApi({
    reducerPath: 'usersAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        getUsers: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.LIST_USERS}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        searchUsers: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_USERS}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        displayUser: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DISPLAY_USER,
                method: 'POST',
                data,
            }),
        }),
        deleteUser: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_USER,
                method: 'POST',
                data,
            }),
        }),
        sendESSInviteToEmp: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SEND_ESS_INVITE_TO_EMP,
                method: 'POST',
                data,
            }),
        }),
        createUser: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_USER,
                method: 'POST',
                data,
            }),
        }),
        modifyUser: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_USER,
                method: 'POST',
                data,
            }),
        }),
        saveUser: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_USER,
                method: 'POST',
                data,
            }),
        }),
        modifyUserAction: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_USER_ACTION,
                method: 'POST',
                data,
            }),
        }),
        userDetailsTab: builder.mutation({
            query: ({ pathToCall, data }) => ({
                url: pathToCall,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const usersBulkUploadAPI = createApi({
    reducerPath: 'usersBulkUploadAPI',
    baseQuery: axiosBaseQuery(restApiBlob),
    endpoints: (builder) => ({
        bulkUploadUsers: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.BULK_UPLOAD_USERS,
                method: 'POST',
                data,
            }),
        }),
        bulkUploadUsersTemplate: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.BULK_UPLOAD_USERS_TEMPLATE,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useGetUsersMutation,
    useSearchUsersMutation,
    useDisplayUserMutation,
    useDeleteUserMutation,
    useSendESSInviteToEmpMutation,
    useCreateUserMutation,
    useModifyUserMutation,
    useSaveUserMutation,
    useModifyUserActionMutation,
    useUserDetailsTabMutation,
} = usersAPI;
export const { useBulkUploadUsersMutation, useBulkUploadUsersTemplateMutation } = usersBulkUploadAPI;
